export default __webpack_public_path__ + "static/media/grafema_clivitalbio_05.0150d085.jpg";